import React from 'react';
import { baseURL } from 'config/api.js';
import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './stockItems.css';
import { AuthContext } from '../../context/AuthContext.jsx';
import { useContext } from 'react';
import Layout from 'components/global/Layout';
import Loader from 'components/global/Loader';
import { FaPlus } from "react-icons/fa6";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import Pagination from 'components/global/pagination';
import { toast } from 'react-toastify';

export const StockItems = () => {
  const [message, setMessage] = useState(null);
  const [stockItems, setStockItems] = useState(null);
  const [stockItemsTotalCount, setStockItemsTotalCount] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingError, setIsLoadingError] = useState(false);
  const { userData } = useContext(AuthContext);
  const [searchParams, setSearchParams] = useSearchParams();

  let page = parseInt(searchParams.get('page'));
  if (isNaN(page))
    page = 1;

  async function fetchData() {
    if (!isLoading) {
      setIsLoading(true);
    }
    let url = `${baseURL}/stockItems?page=${page}`;
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + userData.token
    };
    const response = await fetch(url, {
      method: "GET",
      headers: headers
    });
    const jsonData = await response.json();
    if (!response.ok) {
      toast.error(jsonData.data.message);
      setMessage(jsonData.data.message);
      setIsLoadingError(true);
      setIsLoading(false);
      return; //early return
    }
    const stockItems = jsonData.data.docs;

    setStockItems(stockItems);
    setStockItemsTotalCount(jsonData.data.docsCount);
    setIsLoading(false);
  }

  const handleCurrentPageChange = (page) => {
    searchParams.set('page', page);
    setSearchParams(searchParams);
  }

  const handleDelete = () => {

  }

  useEffect(() => {
    fetchData().catch(e => {
      setIsLoading(false);
      setMessage("An error occurred while communicating with the server.");
      toast.error("An error occurred while communicating with the server.");
    });
    // eslint-disable-next-line
  }, [searchParams]);

  console.log("Before StockItems() rendering");

  if (isLoading || (!isLoading && isLoadingError)) {
    return (
      <Layout>
        <div className='space-y-4'>
          <div className='flex flex-row justify-between items-center px-3'>
            <h2 className='text-2xl text-primary font-bold'>Stock Items</h2>
            {
              (
                userData.doc.isSuperAdmin ||
                userData.doc.isAdmin ||
                userData.role.create.includes("stockitems")
              ) &&
              <Link to="/stockitems/new">
                <button className='flex flex-row items-center bg-[#1A8650] text-white px-3 text-sm py-2 space-x-1 rounded-3xl'>
                  <span><FaPlus /></span>
                  <span>Add Stock Item</span>
                </button>
              </Link>
            }
          </div>
          <div className='flex flex-row justify-start'>
            <div>
              {message && message}
            </div>
          </div>
          {isLoading && <Loader />}
        </div>
      </Layout>
    );
  }

  let stockItemsList = [];

  if (stockItems && stockItems.length !== 0) { //on second render
    stockItemsList = stockItems.map((stockItem, index) => {
      const editLink = "/stockitems/edit/" + stockItem._id;
      return (
        <tr key={stockItem._id}>
          <td className="text-gray-900 px-6 py-3 whitespace-nowrap">{stockItem.stockItemID}</td>
          <td className="text-gray-900 px-6 py-3 whitespace-nowrap">{stockItem.stockItemSKU}</td>
          <td className="text-gray-900 px-6 py-3 whitespace-nowrap">{stockItem.stockItemName}</td>
          <td className="text-gray-900 px-6 py-3 whitespace-nowrap">{stockItem.stockItemUnitOfMeasure}</td>
          <td className="text-gray-900 px-6 py-3 whitespace-nowrap">{stockItem.stockItemCategoryObjectId.stockCategoryName}</td>
          <td className="text-gray-900 px-6 py-3 whitespace-nowrap">{stockItem.currentQuantity}</td>
          <td className="text-gray-900 px-6 py-3 whitespace-nowrap">{stockItem.currentPrice}</td>
          <td className="px-6 py-4 whitespace-nowrap">
            <Link to={editLink}>
              <CiEdit className='text-2xl text-primary' />
            </Link>
          </td>
          <td className="text-primary px-6 py-4 whitespace-nowrap text-center">
            <button onClick={handleDelete}>
              <RiDeleteBin6Line className='text-lg text-[#E30411]' />
            </button>
          </td>
        </tr>
      );
    });
  }

  return (
    <Layout>
      <div className="space-y-4">
        <div className='flex flex-row justify-between items-center px-3'>
          <h2 className='text-2xl text-primary font-bold'>Stock Items</h2>
          {
            (
              userData.doc.isSuperAdmin ||
              userData.doc.isAdmin ||
              userData.role.create.includes("stockitems")
            ) &&
            <Link to="/stockitems/new">
              <button className='flex flex-row items-center bg-[#1A8650] text-white px-3 text-sm py-2 space-x-1 rounded-3xl'>
                <span><FaPlus /></span>
                <span>Add Stock Item</span>
              </button>
            </Link>
          }
        </div>
        <div className='flex flex-row justify-between'>
          {message && message}
        </div>
        <div className='overflow-x-auto rounded-lg border border-[#6843BE]'>
          <table className="w-full table-auto overflow-x-auto">
            <thead className="text-[14px] border border-b-[#6843BE]">
              <tr className='bg-lightSlate'>
                <th scope="col" className="font-semibold text-primary px-6 py-4 text-left">ID</th>
                <th scope="col" className="font-semibold text-primary px-6 py-4 text-left">SKU</th>
                <th scope="col" className="font-semibold text-primary px-6 py-4 text-left">Name</th>
                <th scope="col" className="font-semibold text-primary px-6 py-4 text-left">Unit of Measure</th>
                <th scope="col" className="font-semibold text-primary px-6 py-4 text-left">Category</th>
                <th scope="col" className="font-semibold text-primary px-6 py-4 text-left">Current Quantity</th>
                <th scope="col" className="font-semibold text-primary px-6 py-4 text-left">Unit Price</th>
                <th scope="col" className="font-semibold text-primary px-6 py-4 text-left">Edit</th>
                <th scope="col" className="font-semibold text-primary px-6 py-4 text-left">Delete</th>
              </tr>
            </thead>
            <tbody className='text-[13px] p-4'>
              {stockItemsList}
            </tbody>
            <tfoot className='w-full bg-lightSlate border border-b-[#6843BE] border-t-[#6843BE]'>
              <tr>
                <td colSpan='8'>
                  <Pagination
                    currentPage={page}
                    pageCount={Math.ceil(stockItemsTotalCount / pageSize)}
                    setPage={handleCurrentPageChange}
                  />
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </Layout>
  );
}
